import { Divider } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import { SeverityType } from '@aon/tws-common-ui-questions/build/lib/models';
import * as React from 'react';
import styled from 'styled-components';
import { SurveyStep } from '../../models';
import { WarningBox } from '../common/warnings';

export interface ISectionBreakRowProps {
	propertyErrors: string[];
	propertyWarnings: string[];
	linkToWarnings?: SurveyStep;
	linkToErrors?: SurveyStep;
}

export const SectionBreak = styled(Divider)`
	border-color: ${globalVars.gray1};
	margin: 0 2px 0 0;
	display: flex;
	display: -ms-flexbox;
	display: -webkit-flex;
	align-items: center;
	justify-content: center;
	flex: 1 1 0%;
	-webkit-flex: 1 1 0%;
	-ms-flex: 1 1 0%;
`;
SectionBreak.displayName = 'SectionBreak';

export const SectionBreakRow = (props: ISectionBreakRowProps) => {
	const { propertyErrors, propertyWarnings, linkToErrors, linkToWarnings } = props;
	return (
		<>
			<SectionBreak type='dashed' />
			{propertyWarnings.length > 0 && (
				<WarningBox severity={SeverityType.Warning} messages={propertyWarnings} linkToStep={linkToWarnings} />
			)}
			{propertyErrors.length > 0 && <WarningBox severity={SeverityType.Error} messages={propertyErrors} linkToStep={linkToErrors} />}
		</>
	);
};
